export default "__VITE_ASSET__3883d2cf__"